var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAppStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3384 8.14875C22.1989 8.2572 19.7512 9.636 19.7512 12.7034C19.7512 16.251 22.865 17.5059 22.958 17.5368C22.9426 17.6142 22.4622 19.2564 21.3158 20.9295C20.2934 22.4013 19.2244 23.873 17.5978 23.873C15.9712 23.873 15.5528 22.928 13.6783 22.928C11.8502 22.928 11.1995 23.904 9.71225 23.904C8.225 23.904 7.187 22.5407 5.9942 20.8676C4.6154 18.9 3.5 15.8481 3.5 12.9512C3.5 8.30355 6.521 5.84025 9.49535 5.84025C11.0756 5.84025 12.3923 6.87825 13.3838 6.87825C14.3288 6.87825 15.8006 5.7783 17.5976 5.7783C18.2794 5.77845 20.7272 5.84055 22.3384 8.14875ZM16.7457 3.81105C17.4893 2.928 18.0161 1.70415 18.0161 0.4803C18.0161 0.3099 18.0007 0.1395 17.9696 0C16.7612 0.0465 15.3204 0.805651 14.4529 1.8126C13.7712 2.5872 13.136 3.81105 13.136 5.0505C13.136 5.23635 13.1671 5.42235 13.1825 5.4843C13.2599 5.49975 13.384 5.51535 13.5079 5.51535C14.5924 5.5152 15.9555 4.7871 16.7457 3.81105Z",
    fill: "#637789"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppStore);
export default __webpack_public_path__ + "static/media/icon_app_store.3b36ac946de1d03508cecd06df2f4616.svg";
export { ForwardRef as ReactComponent };